import React, {useState} from 'react';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import CssBaseline from '@material-ui/core/CssBaseline';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Icon from '@material-ui/core/Icon';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Paper from '@material-ui/core/Paper';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import MailIcon from '@material-ui/icons/Mail';
import Timeline from './Timeline';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import theme from './Themer';
import { ThemeProvider } from '@material-ui/core/styles';
import Copyright from './Copyright'
import { VariableSizeList } from 'react-window';
import { Link } from 'react-scroll'
import Grow from '@material-ui/core/Grow';
import { Animator, ScrollContainer, ScrollPage, batch, Fade, FadeOut, Move, MoveIn, MoveOut, Sticky, StickyIn, ZoomIn } from "react-scroll-motion";
import mainLogo from'./images/bib15.png';
import XVBackground from './images/xvbackground.png'; // Import using relative path
import PintuBackground from './images/pintubackground.png'; // Import using relative path
import JudgingCriteria from './images/judging-criteria.pdf'; // Import using relative path
import { Document, Page, pdfjs } from "react-pdf";
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import WebIcon from '@material-ui/icons/Web';
import YouTube from 'react-youtube';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;





const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'center',
    },
    appBar: {
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: drawerWidth,
    },
    title: {
        flexGrow: 1,
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerPaper: {
        width: drawerWidth,
    },
    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
        justifyContent: 'flex-start',
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: 0,
    },
    contentShift: {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: drawerWidth,
    },
    iconRoot: {
        marginRight: theme.spacing(2),
        textAlign: 'center',
    },
    loginButton: props => ({
        background: props.palette.gradient.default,
        color: 'black',
        marginLeft: theme.spacing(1),
    }),
    imageIcon: {
        height: '100%',
        marginBottom: theme.spacing(1),
      },
      

}));

const styles = {
    paperContainer: {
        backgroundImage: `url(${XVBackground})`,
        backgroundPosition: "center center",
        backgroundSize: "contain",
        height: "100vh",
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
        // display: 'flex',
        

    },
    pintuContainer: {
        backgroundImage: `url(${PintuBackground})`,
        backgroundPosition: "center center",
        backgroundSize: "contain",
        height: "100vh",
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
        // display: 'flex',
    }
}

var ruleList = [];
for (var i = 0; i <= 21; i++) {
    ruleList.push(i);
}

function getRuleContent(rule) {
    switch (rule) {
        case 0:
            return "The competition is open to any collegiate or independent team.";
        case 1:
            return "The Bhangra in the Burgh XV Executive Board reserves the right to refuse the registration of any team.";
        case 2:
            return "The final, late application deadline for when all registration information must be received is 11:59pm on Friday, October 1st. All application materials must be received by this time.";
        case 3:
            return "The application fee is non-refundable to all teams that apply.";
        case 4:
            return "Each team must have a minimum of 8 dancers and no more than 16 dancers on stage. Instrumentalists (dholi, chimta, etc.), singers, and alternate dancers will not count towards the 16 dancer limit but will count towards the 20 team member limit. They must be included on the roster. No more than 20 total team members may be on the roster, but there is no limit on how many will be allowed at mixer (fee/extra person). However, these extra people will not be allowed during tech time or backstage of the show.";
        case 5:
            return "One additional person for each team will be permitted to serve as the team manager.";
        case 6:
            return "On the day of the competition, each member of a team must present their photo ID in order to enter the venue and perform.";
        case 7:
            return "Each performance must be a minimum of seven minutes and cannot be longer than nine minutes. If performance includes a sher, mela, etc., the time for the extra segment must be included in the mix. Any team that exceeds this time limit will suffer a point deduction (see rubric).";
        case 8:
            return "A mandatory dress rehearsal, beginning at 8 am, will be held on the day of the show. Each team will be assigned 25 minutes of stage time. If any team misses its assigned time slot, they will not be reassigned to practice their routine on the stage.";
        case 9:
            return "All music must be on one continuous track. Any breaks, pauses, or blank time must be pre-recorded into the track.";
        case 10:
            return "No team will be allowed to view another team’s performance under any circumstances, including dress rehearsal, prior to the actual competition.";
        case 11:
            return "No dancer will be allowed to perform for more than one team.";
        case 12:
            return "Consumption of alcohol or illegal substances at the competition or mixer venue will not be tolerated. Violation will result in disqualification and expulsion of the team. Furthermore, no smoking is allowed at either venue.";
        case 13:
            return "No team will be permitted to use any props that will alter the stage in any manner. The Bhangra in the Burgh XV Executive Board reserves the right to deny the use of any props.";
        case 14:
            return "A prop list must be sent to the Executive Board along with the post-acceptance packet.";
        case 15:
            return "Teams are expected to comply with all deadlines after declaring intent to participate in the competition. Failure to comply with particular deadlines may result in a fine.";
        case 16:
            return "Due to the fact that Bhangra in the Burgh is affiliated with Carnegie Mellon University, we must abide by the institution’s guidelines for all financial purposes. All independent teams applying to the competition must have a university-affiliated account in order to be paid the full prize money if they place. In the event that an independent team does not have a university-affiliated account, the individual receiving the prize money will have to pay taxes on this money by the end of the year.";
        case 17:
            return "A complete list of the venue’s rules will be sent to accepted teams. Teams are expected to comply with these rules.";
        case 18:
            return "Obnoxious, rude, or impermissible behavior will not be tolerated at the hotel or after-party. This may be grounds for point deduction or disqualification.";
        case 19:
            return "Any damage to any of the venues, facilities, and/or transportation will be the liability of the team.";
        case 20:
            return "All team members and team managers are responsible for rules outlined.";
        case 21:
            return "The Bhangra in the Burgh XV Executive Board reserves the right to add new or updated rules upon their discretion with regards to the venue and the competition. All teams will be notified via email of any such changes.";
        default:
            return "";
    }
}

function renderRow(index) {
    // const { index, style } = props;
    // button style={style}
    return (
        <ListItem key={index}>
            <ListItemText primary={`${index + 1}. ${getRuleContent(index)}`} />
        </ListItem>
    );
}

const getItemSize = index => {
    switch (index) {
        case 4:
            return 80;
        default:
            return 50;
    }
}


export default function Main(props) {
    const currentTheme = theme();
    const classes = useStyles(currentTheme);
    const { history } = props;
    const preventDefault = (event) => event.preventDefault();

    const handleLogin = () => {
        history.push("/login")
    };

    const handleSignUp = () => {
        history.push("/register")
    };
    const FadeUp = batch( Fade(), Move(0,0, null, 0));

    const [numPages, setNumPages] = useState(3);
  const [pageNumber, setPageNumber] = useState(1);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  function handleNextPage() {
      setPageNumber(pageNumber + 1);
  }
  function handleBackPage() {
    setPageNumber(pageNumber - 1);
}

  const opts = {
    height: '500',
    width: '840',
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 1,
    },
  };


    return (
        <div className={classes.root}>
            <ThemeProvider theme={currentTheme}>
                <CssBaseline />
                <AppBar
                    position="fixed"
                    className={clsx(classes.appBar)}
                >
                    <Toolbar>
                    <Icon classes={{root: classes.iconRoot}}>
                    <img className={classes.imageIcon} src={mainLogo}/>
                    </Icon>
                        <Typography variant="h6" noWrap className={classes.title}>
                            BIB XV Registration Portal
          </Typography>
                        {/* <ButtonGroup variant="contained" color="primary" aria-label="contained primary button group"> */}
                            <Button classes={{ root: classes.loginButton }} onClick={handleLogin}>Login </Button>
                            <Button classes={{ root: classes.loginButton }} onClick={handleSignUp}>Sign Up</Button>
                        {/* </ButtonGroup> */}
                    </Toolbar>
                </AppBar>
                <Box p={5} />
                <Grid container alignItems="center" justifyContent="center">
                    <Container maxWidth="lg">
                        <main
                            className={clsx(classes.content)}
                        >
                            <div className={classes.drawerHeader} />
                            <ScrollContainer>
                                <ScrollPage page={0}>
                                    <Animator animation={FadeUp}>
                                    <Grid
                                    container
                                    direction="column"
                                    // justify="center"
                                    alignItems="right"
                                    style={styles.paperContainer} >
                                        <Typography variant="h2" gutterBottom>
                                            WELCOME to the BIB Registration Portal
        </Typography>

                                        <Typography paragraph>
                                            Dear Prospective Bhangra Team,
        </Typography>
                                        <Typography paragraph>
                                            The Bhangra in the Burgh XV Executive Board of Carnegie Mellon University in Pittsburgh is proud to present our fifteenth annual bhangra competition on Saturday, November 20th, 2021 at Soldiers and Sailors Museum and Memorial Auditorium in Pittsburgh, Pennsylvania. Bhangra in the Burgh is a stage for top bhangra teams from across the nation to showcase the energy and culture that Bhangra represents as well as an opportunity to donate all of our proceeds to our chosen charity.

        </Typography>
                                        <Typography paragraph>
                                            Since our first competition in 2007, Bhangra in the Burgh has grown exponentially and
                                            currently stands as one of the largest student-run events in Pittsburgh. Over the past fourteen
                                            years, Bhangra in the Burgh has attracted a range of audience members each year and raised
                                            a total of over $100,000 for charity. With Bhangra in the Burgh XV, we hope to raise more than ever before to celebrate our 15th year of giving back to the community.

        </Typography>
                                        <Typography paragraph>
                                            The following page is a timeline of all important registration dates. This year, we have released an online application portal at bhangraintheburgh.org. Please use this app portal to create an account for your team and submit all of your application materials. If for any reason you experience technical difficulties, you have the option to fill out the Registration Packet PDF and submit your materials to bhangraintheburgh@gmail.com according to the application deadline. The regular application deadline is 11:59 pm on Friday, September 24th, 2021, for a fee of $120. The late registration deadline is 11:59 pm on Friday, October 1st, 2021, for a fee of $140. All payments should be made through our Eventbrite (payment information on the following page). We will send you a confirmation email upon receiving these materials. Applications received after the above-mentioned time will not be considered for participation. After receiving your application materials, we will notify your team’s primary contact of your participation status no later than Monday, October 4th, 2021. You will have 48 hours to confirm your participation in the event.

        </Typography>
                                        <Typography paragraph>
                                            Thank you for your interest in Bhangra in the Burgh XV. More information about the venue, the committee, and the event will be online soon at bhangraintheburgh.org. In the meantime, feel free to contact us. We look forward to your application, and hope to see you on November 20th!
        </Typography>
                                        <Typography paragraph>
                                            Best Regards,
                                            Bhangra in the Burgh XV Executive Board

        </Typography>
        </Grid>
                                    </Animator>
                                </ScrollPage>
                                



                                <ScrollPage page={1}>
                                    <Animator animation={FadeUp}>
                                    <Grid
                                    container
                                    direction="column"
                                    // justify="center"
                                    alignItems="right"
                                    style={styles.pintuContainer} >
                                        <Typography variant="h2" gutterBottom>
                                            Timeline
        </Typography>
        <Box minWidth="50vw">
                                        <Timeline />
                                        
                                        </Box>
                                        </Grid>
                                    </Animator>
                                </ScrollPage>
                                <ScrollPage page={2}>
                                    <Animator animation={FadeUp}>
                                        <Typography variant="h2" gutterBottom>
                                            {'Rules & Regulations'}
                                        </Typography>
                                        <Paper style={{ maxHeight:"70vh", overflow: 'auto', backgroundColor: 'transparent', boxShadow: 'none' }}>
                                            <List>
                                                {ruleList.map((index) => renderRow(index))}
                                            </List>
                                        </Paper>
                                    </Animator>
                                </ScrollPage>

                                <ScrollPage page={3}>
                                    <Animator animation={FadeUp}>
                                        <Typography variant="h2" gutterBottom>
                                            Judging Criteria
        </Typography>
        <Grid container alignItems="center" justifyContent="center"   direction="column" >
        <Document
        file={JudgingCriteria}
        onLoadSuccess={onDocumentLoadSuccess}
      >
        <Page pageNumber={pageNumber} width={500}/>
      </Document>
      <Grid container alignItems="center" justifyContent="center" direction="row">
      <Button
                    disabled={pageNumber === 1}
                    className={classes.button}
                    onClick={handleBackPage}

                  >
                    Back
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleNextPage}
                    disabled={pageNumber === 3}
                    className={classes.button}
                  >
                    Next
                  </Button>
                  </Grid>
      </Grid>
                                       
                                    </Animator>
                                </ScrollPage>
                                <ScrollPage page={4}>
                                    <Animator animation={FadeUp}>
                            <Typography variant="h2" gutterBottom>
                                How to use the portal
        </Typography>
        <Grid container justifyContent="center" alignItems="center">
        <YouTube videoId="X38lfmDJft8" opts={opts}  />
        </Grid>
        </Animator>
                                </ScrollPage>
                                
        </ScrollContainer>
                        </main>
                    </Container>
                </Grid>
                <footer className={classes.footer}>
      <Container maxWidth="lg">
        <Typography variant="h6" align="center" gutterBottom>
          {"Contact Us"}
        </Typography>
        <Grid container direction="row" justifyContent="center" alignItems="center">
        <IconButton aria-label="mail" onClick={()=> window.open("mailto:bhangraintheburgh@gmail.com")}>
        <MailIcon />
      </IconButton>
      <IconButton aria-label="facebook" onClick={()=> window.open("https://www.facebook.com/bhangraintheburgh", "_blank")}>
        <FacebookIcon />
      </IconButton>
      <IconButton aria-label="instagram" onClick={()=> window.open("https://www.instagram.com/bhangraintheburgh", "_blank")}>
        <InstagramIcon />
      </IconButton>
      <IconButton aria-label="website" onClick={()=> window.open("https://www.bhangraintheburgh.org", "_blank")}>
        <WebIcon />
      </IconButton>
      </Grid>
      <Grid container direction="row" justifyContent="center" alignItems="center">
      <Typography variant="h7" align="center" gutterBottom>
          {"For urgent concerns, please call 714-478-9797"}
        </Typography>
      </Grid>
        <Copyright />
      </Container>
    </footer>
            </ThemeProvider>
        </div>
    );

    // _onReady(event) {
    //     // access to player in all event handlers via event.target
    //     event.target.pauseVideo();
    //   }
}